import { Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { fiord, modalShadow } from 'components/style/Colors.style';
import styled, { css } from 'styled-components';

const fontStyle = css`
  letter-spacing: 0.0375rem;
  color: ${fiord};
`;

export const FeedbackModal = styled(Modal)`
  border-radius: 0.3125rem;
  box-shadow: 0 0.25rem 1.5rem 0 ${modalShadow};
  max-width: 37.75rem;
`;

export const Title = styled(ModalHeader).attrs({
  className: 'border-0 pb-0'
})`
  .modal-title {
    ${fontStyle};
    font-size: 0.875rem;
    font-weight: 500;
  }
`;

export const InputLabel = styled(Label).attrs({})`
  ${fontStyle};
  font-size: 0.75rem;
`;

export const Body = styled(ModalBody).attrs({
  className: 'pl-3 pr-5 pt-1'
})``;

export const Subtitle = styled.p`
  ${fontStyle} font-size: 0.75rem;
`;



// WEBPACK FOOTER //
// ./src/components/pages/Feedback/Feedback.style.js